import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ITeacherAttendanceApiResponse,
  TeacherAttendanceState,
} from '../../interface/teacherAttendanceModel';
import {
  fetchAllStaffAttendance,
  checkInTeachersAttendance,
  checkOutTeachersAttendance,
  markAbsentTeachersAttendance,
  markLeaveTeachersAttendance,
  deleteAttendance,
} from '../action/teacherAttendance.action';
import { IErrorResponse } from '../../interface';

export const initialState: TeacherAttendanceState = {
  Summary: {
    absentCount: 0,
    leaveCount: 0,
    presentCount: 0,
    pendingCount: 0,
    checkOutCount: 0,
  },
  userAttendance: [],
  total: 0,
  page: 1,
  pageSize: 5,
  totalPages: 0,
  isLoading: true,
  error: null,
};

const teacherAttendanceSlice = createSlice({
  name: 'teacherAttendance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllStaffAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.userAttendance = initialState.userAttendance;
        state.total = initialState.total;
        state.Summary = initialState.Summary;
        state.page = initialState.page;
        state.pageSize = initialState.pageSize;
        state.totalPages = initialState.totalPages;
      })
      .addCase(
        fetchAllStaffAttendance.fulfilled,
        (state, action: PayloadAction<ITeacherAttendanceApiResponse>) => {
          state.isLoading = false;
          state.error = null;
          state.userAttendance = action.payload.data.userAttendance;
          state.total = action.payload.data.total;
          state.page = action.payload.data.page;
          state.Summary = action.payload.data.Summary;
          state.pageSize = action.payload.data.pageSize;
          state.totalPages = action.payload.data.total;
        },
      )

      .addCase(fetchAllStaffAttendance.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
        state.userAttendance = initialState.userAttendance;
        state.total = initialState.total;
        state.page = initialState.page;
        state.pageSize = initialState.pageSize;
        state.totalPages = initialState.totalPages;
      })

      // checkin
      .addCase(checkInTeachersAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkInTeachersAttendance.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })

      .addCase(
        checkInTeachersAttendance.rejected,
        (state, action: PayloadAction<IErrorResponse>) => {
          state.isLoading = false;
          state.error = action.payload.message;
        },
      )

      // checkout
      .addCase(checkOutTeachersAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkOutTeachersAttendance.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })

      .addCase(
        checkOutTeachersAttendance.rejected,
        (state, action: PayloadAction<IErrorResponse>) => {
          state.isLoading = false;
          state.error = action.payload.message;
        },
      )
      // absent
      .addCase(markAbsentTeachersAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(markAbsentTeachersAttendance.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(
        markAbsentTeachersAttendance.rejected,
        (state, action: PayloadAction<IErrorResponse>) => {
          state.isLoading = false;
          state.error = action.payload.message;
        },
      )
      // leave
      .addCase(markLeaveTeachersAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(markLeaveTeachersAttendance.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(
        markLeaveTeachersAttendance.rejected,
        (state, action: PayloadAction<IErrorResponse>) => {
          state.isLoading = false;
          state.error = action.payload.message;
        },
      )
      // delete attendance
      .addCase(deleteAttendance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteAttendance.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(deleteAttendance.rejected, (state, action: PayloadAction<IErrorResponse>) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default teacherAttendanceSlice.reducer;
